import Vue from 'vue'
import VueRouter from 'vue-router'
import configurazioni from '@/services/configurazioniService'
import store from '@/store'

Vue.use(VueRouter)

var layoutCorrente
var template, multiazienda

const routes = [
  {
    path: '/',
    name: 'Home',
    // component: Home
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // Nel caso debba entrare subito su layout
    component: async () => {
      if (!layoutCorrente) {
        const infoLayout = await configurazioni.getCurrentLayout()
        layoutCorrente = infoLayout.base
        template = infoLayout.template
        multiazienda = infoLayout.multiazienda
        store.commit('SET_MULTI_AZIENDA', multiazienda)
        if (template && !template.startsWith(layoutCorrente)) {
          template = `${layoutCorrente}_${template}`
        }
      }
      // per uniformare Layout04 con Layout_04 (uno su impostazioni, l'altro su gruppi_tasti, basta cambiare il valore su impostazioni e sostituire i case sotto)
      switch (layoutCorrente) {
        case 'layout01':
        case 'layout_01':
          store.commit('SET_LAYOUT_TASTI', template || 'layout_01') // c'è underscore prima di 01 ...
          return import('../views/Layout_01/Layout.vue')
        case 'layout02':
        case 'layout_02':
          store.commit('SET_LAYOUT_TASTI', template || 'layout_02') // c'è underscore prima di 01 ...
          return import('../views/Layout_02/Layout.vue')
        case 'layout_03':
          store.commit('SET_LAYOUT_TASTI', template || 'layout_03') // c'è underscore prima di 01 ...
          return import('../views/Layout_03/Layout.vue')
        case 'layout04':
        case 'layout_04':
          // Apro sempre la view Layout_04 ma potrei passare layoutTasti = layout_04_ottici, layout_04_abbigliamento, etc.
          store.commit('SET_LAYOUT_TASTI', template || 'layout_04') // c'è underscore prima di 04 ...
          return import('../views/Layout_04/Layout.vue')
        case 'layout05':
        case 'layout_05':
          store.commit('SET_LAYOUT_TASTI', template || 'layout_05') // c'è underscore prima di 05 ...
          return import('../views/Layout_05/Layout.vue')
        case 'layout06':
        case 'layout_06':
          store.commit('SET_LAYOUT_TASTI', template || 'layout_06') // c'è underscore prima di 06 ...
          return import('../views/Layout_06/Layout.vue')
        case 'layout_10':
          store.commit('SET_LAYOUT_TASTI', template || 'layout_10') // c'è underscore prima di 06 ...
          return import('../views/Layout_10/Layout.vue')
        default:
          return import('../views/Layout_05/Layout.vue')
      }
    }
  },
  {
    path: '/1',
    name: 'Layout01',
    // component: () => import(/* webpackChunkName: "layout04" */ '../views/Layout_04/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_01')
      return import(/* webpackChunkName: "layout01" */ '../views/Layout_01/Layout.vue')
    }
  },
  {
    path: '/2',
    name: 'Layout02',
    // component: () => import(/* webpackChunkName: "layout02" */ '../views/Layout_02/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_02')
      return import(/* webpackChunkName: "layout02" */ '../views/Layout_02/Layout.vue')
    }
  },
  {
    path: '/3',
    name: 'Layout03',
    // component: () => import(/* webpackChunkName: "layout02" */ '../views/Layout_02/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_03')
      return import(/* webpackChunkName: "layout02" */ '../views/Layout_03/Layout.vue')
    }
  },
  {
    path: '/4/:template?',
    name: 'Layout04',
    // component: () => import(/* webpackChunkName: "layout04" */ '../views/Layout_04/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_04')
      return import(/* webpackChunkName: "layout04" */ '../views/Layout_04/Layout.vue')
    },
    props: route => ({ template: route.params.template })
  },
  {
    path: '/5/:template?',
    name: 'Layout05',
    // component: () => import(/* webpackChunkName: "layout05" */ '../views/Layout_05/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_05')
      return import(/* webpackChunkName: "layout05" */ '../views/Layout_05/Layout.vue')
    },
    props: route => ({ template: route.params.template })
  },
  {
    path: '/6/:template?',
    name: 'Layout06',
    // component: () => import(/* webpackChunkName: "layout06" */ '../views/Layout_06/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_06')
      return import(/* webpackChunkName: "layout06" */ '../views/Layout_06/Layout.vue')
    },
    props: route => ({ template: route.params.template })
  },
  {
    path: '/10/:template?',
    name: 'Layout10',
    // component: () => import(/* webpackChunkName: "layout06" */ '../views/Layout_06/Layout.vue')
    component: async () => {
      const infoLayout = await configurazioni.getCurrentLayout()
      store.commit('SET_MULTI_AZIENDA', infoLayout.multiazienda)
      store.commit('SET_LAYOUT_TASTI', 'layout_10')
      return import(/* webpackChunkName: "layout06" */ '../views/Layout_10/Layout.vue')
    },
    props: route => ({ template: route.params.template })
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/import',
    name: 'Import',
    component: () => import(/* webpackChunkName: "import" */ '../views/import/Import.vue')
  },
  {
    path: '/token',
    name: 'Token',
    component: () => import(/* webpackChunkName: "token" */ '../views/licenza/TokenScaduto.vue')
  },
  {
    path: '/licenza',
    name: 'Licenza',
    component: () => import(/* webpackChunkName: "licenza" */ '../views/licenza/LicenzaScaduta.vue')
  },
  {
    path: '/slide',
    name: 'Slide',
    component: () => import(/* webpackChunkName: "slide" */ '../views/Slide/slide.vue')
  },
  {
    path: '/pdf',
    name: 'Pdf',
    component: () => import(/* webpackChunkName: "pdf" */ '../views/PdfViewer/viewer.vue'),
    props: route => ({ source: route.params.source })
  },
  {
    path: '/pdf-e',
    name: 'Pdf-e',
    props: route => ({ source: route.params.source }),
    meta: { external: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const match = router.matcher.match
router.matcher.match = (...args) => {
  const route = match.apply(router, args)
  if (!route.meta.external) {
    return route
  }
  if (route.params && route.params.source) {
    return Object.freeze({ ...route, fullPath: route.params.source })
  } else {
    return Object.freeze({ ...route, fullPath: route.path })
  }
}

// Override resolver to fix external links.
const resolve = router.resolve
router.resolve = (...args) => {
  const resolved = resolve.apply(router, args)
  if (resolved.route.meta.external) {
    resolved.href = resolved.route.fullPath
  }
  return resolved
}

// Handle external routes.
router.beforeEach((to, from, next) => {
  if (to.meta.external) {
    if (to.meta.newWindow || to.params.newWindow) {
      window.open(to.fullPath)
    } else {
      window.location.replace(to.fullPath)
    }
    return next(false)
  }
  if (!to.meta.layout) {
    to.meta.layout = 'Default'
  }
  next()
})

export default router
